define('score_bootstrap/Components/ContentSearch/SearchClient',[
    "jquery",
    "eventManager",
    "score_ccf/Events/ModulesLoadedEvent",
    "score_bootstrap/Events/SearchResponseEvent",
    "score_bootstrap/Events/SearchRequestChangeEvent",
    "score_bootstrap/Models/Search/IndexableItemBase",
    "score_bootstrap/Models/Search/SimpleSearchClient",
    "score_bootstrap/Utils/UrlHelper"
], function (
    $,
    eventManager,
    ModulesLoadedEvent,
    SearchResponseEvent,
    SearchRequestChangeEvent,
    IndexableItemBase,
    SimpleSearchClient,
    UrlHelper
) {
    "use strict";

    function indexMatchToModel(indexMatch) {
        return new IndexableItemBase(
            indexMatch.ID,
            indexMatch.Title,
            indexMatch.Tiles,
            indexMatch.Url
        );
    }

    function SearchClient(scope, refreshEvents, perPage, language, root, indexName, templates, searchUrl, uniqueId, tileNames, flags, lazySearch) {
        var modulesLoaded = false,
            urlParam = uniqueId + "page",
            page = UrlHelper.getHashValue(urlParam),
            startPage = page, // load only current page
            parent = {},
            self = this;
        SimpleSearchClient.call(this, searchUrl, perPage, language, root, indexName, templates, startPage, page, tileNames);

        if (typeof (flags) === "object") {
            this.searchRequest.flags = flags;
        }

        function handleError(err) {
            refreshEvents.forEach(function (ev) {
                eventManager.trigger(SearchResponseEvent.serverError + ":" + ev, err);
            });
        }

        function parseResults(query, results) {
            var indexMatch = results.SearchResults || [];
            return new SearchResponseEvent(
                query,
                indexMatch.map(indexMatchToModel),
                results.PageNumber ? results.PageNumber : 0,
                results.NumberOfResultsPerPage,
                results.TotalNumberOfResults,
                results.NumberOfPages,
                results.FacetCounts
            );
        }

        this.triggerSearchResponseEvent = triggerSearchResponseEvent;

        function triggerSearchResponseEvent(data) {
            // Search Results component has a reference to its Search Client, so Search Results can
            // add listener directly to Search Client without using Event Manager
            $(scope).triggerHandler(SearchResponseEvent.eventName, data);

            eventManager.trigger(SearchResponseEvent.eventName + ":pageLoaded", data);

            // Other components like Facet Container still rely on Event Manager
            refreshEvents.forEach(function (ev) {
                eventManager.trigger(SearchResponseEvent.eventName + ":" + ev, data);
            });
        }

        parent.search = this.search.bind(this);
        this.search = function search() {
            var deferred = $.Deferred();

            // if lazy search is turned on and query string is empty
            // don't dispatch search request and return empty result set
            if (lazySearch && !this.searchRequest.query) {
                deferred.resolve(parseResults(this.searchRequest.query, {}));
            } else {
                deferred = parent.search().then(parseResults.bind(null, this.searchRequest.query), handleError);
            }
                
            return deferred;
        };

        // run a search query on page load
        eventManager.subscribe(ModulesLoadedEvent.name, function () {
            if (modulesLoaded === true) return;
            modulesLoaded = true;
            self.search().done(triggerSearchResponseEvent);
        });

        if (flags && flags["Live Search"] === "true") {
            // run a search query when the query in the search box changes
            eventManager.subscribe(SearchRequestChangeEvent.queryChange, function (newQuery) {
                this.searchRequest.query = newQuery;
                this.searchRequest.startPage = 0;
                this.searchRequest.page = 0;
                this.search().done(triggerSearchResponseEvent);
            }.bind(this));
        }

        function refresh(props) {
            $.each(props, function (key, val) {
                if (self.searchRequest.hasOwnProperty(key)) {
                    self.searchRequest[key] = val;
                }
            });

            if (modulesLoaded === true) {
                self.search().done(triggerSearchResponseEvent);
            }
        }

        if (refreshEvents.length) {
            refreshEvents.forEach(function (ev) {
                eventManager.subscribe(SearchRequestChangeEvent.eventName + ":" + ev, refresh);
            });
        }

        eventManager.subscribe(SearchRequestChangeEvent.customDataEvent, function (customData) {
			this.searchRequest.customData = $.extend(this.searchRequest.customData, customData);
			this.search().done(triggerSearchResponseEvent);
		}.bind(this));
    }

    SearchClient.prototype = Object.create(SimpleSearchClient.prototype);

    SearchClient.init = function init(args) {
        return args.IsEditorEditing === true ? null : new SearchClient(
            args.scope,
            args.RefreshActionMessages || [],
            args.PerPage,
            args.Language,
            args.SearchRoot,
            args.IndexName,
            args.Templates,
            args.SearchApiUrl,
            args.UniqueId,
            args.TileNames,
            args.SearchFlags,
            args.LazySearch
        );
    };

    return SearchClient;
});
